<template>
  <div :class="$style.icons">
    <font-awesome-icon v-if="hasDial && hasPhoneButton" :icon="faPhone" flip="horizontal" :class="$style.icon" @click="dispatch(phone, phoneType)" />
    <font-awesome-icon v-if="hasDial && hasMobileButton" :icon="faMobileAlt" :class="$style.icon" @click="dispatch(phone, mobileType)" />
    <font-awesome-icon v-if="hasSms && hasSmsButton" :icon="faCommentLines" :class="$style.icon" @click="dispatch(phone, smsType)" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faPhone } from '@fortawesome/pro-solid-svg-icons/faPhone'
import { faMobileAlt } from '@fortawesome/pro-solid-svg-icons/faMobileAlt'
import { faCommentLines } from '@fortawesome/pro-solid-svg-icons/faCommentLines'

const { mapGetters } = createNamespacedHelpers('dialer')

export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    contact: {
      required: true,
      type: Object
    },
    phone: {
      required: true,
      type: Object
    },
    hasPhoneButton: {
      type: Boolean,
      default: true
    },
    hasMobileButton: {
      type: Boolean,
      default: true
    },
    hasSmsButton: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      faPhone,
      faMobileAlt,
      faCommentLines,
      phoneType: 'JIMINNY.SOFTPHONE.PHONE',
      mobileType: 'JIMINNY.SOFTPHONE.MOBILE',
      smsType: 'JIMINNY.SMS'
    }
  },
  computed: {
    ...mapGetters([
      'hasDial',
      'hasSms'
    ])
  },
  methods: {
    dispatch (phone, type) {
      this.$router.push({
        path: 'phone-controller',
        query: {
          type: encodeURIComponent(type),
          phone: encodeURIComponent(phone.number),
          recordId1: encodeURIComponent(this.contact.crmId),
          objectType: encodeURIComponent(this.contact.prospectType)
        }
      })
    }
  }
}
</script>

<style module lang="less" src="./ContactButtons.less"></style>



// WEBPACK FOOTER //
// ContactButtons.vue?1cbee57a